import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        VRow,
        [
          _c(VCol, { attrs: { cols: "12" } }, [
            _c("h6", { staticClass: "title-modal" }, [
              _c(
                "span",
                { staticStyle: { color: "#515154", "font-size": "14px" } },
                [_vm._v("workspace /")]
              ),
              _c(
                "span",
                { staticStyle: { color: "#515154", "font-size": "14px" } },
                [_vm._v("dataset:")]
              ),
              _c("span", {
                staticStyle: { display: "inline-block", width: "10px" },
              }),
              _c("span", [_vm._v(_vm._s(this.item.path_name) + " /")]),
              _c("span", [_vm._v(_vm._s(this.item.object_name))]),
            ]),
          ]),
        ],
        1
      ),
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c(
                VTabs,
                {
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                },
                [
                  _c(
                    VTab,
                    {
                      on: {
                        click: function ($event) {
                          _vm.tabActive = "GENERAL"
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("my_tasks.modals.general")))]
                  ),
                  _c(
                    VTab,
                    {
                      on: {
                        click: function ($event) {
                          _vm.tabActive = "TABLES"
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("my_tasks.modals.datasource")) + "s")]
                  ),
                  _c(
                    VTab,
                    {
                      on: {
                        click: function ($event) {
                          _vm.tabActive = "BUSINESS_TERM"
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("my_tasks.modals.bterm")))]
                  ),
                  _c(
                    VTab,
                    {
                      on: {
                        click: function ($event) {
                          _vm.tabActive = "USER_ACCESS"
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("my_tasks.modals.user_access")))]
                  ),
                  _c(
                    VTab,
                    {
                      on: {
                        click: function ($event) {
                          _vm.tabActive = "LINEAGE"
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("my_tasks.modals.lineage")))]
                  ),
                  _c(
                    VTab,
                    {
                      on: {
                        click: function ($event) {
                          _vm.tabActive = "HISTORY_LOGS"
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("my_tasks.modals.hlogs")))]
                  ),
                ],
                1
              ),
              _c(
                VTabsItems,
                {
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                },
                [
                  _c(
                    VTabItem,
                    { staticClass: "pt-2" },
                    [
                      _c(
                        VForm,
                        {
                          ref: "form",
                          attrs: { "lazy-validation": "" },
                          model: {
                            value: _vm.validform,
                            callback: function ($$v) {
                              _vm.validform = $$v
                            },
                            expression: "validform",
                          },
                        },
                        [
                          _c("dataset-tab-general", {
                            attrs: {
                              item: _vm.item,
                              valid: _vm.valid,
                              readonly: _vm.readonly,
                              isChangeRequest: _vm.isChangeRequest,
                            },
                            on: { onShowDataset: _vm.onShowDataset },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VTabItem,
                    { staticClass: "pt-2" },
                    [
                      _c("dataset-tab-tables", {
                        attrs: {
                          item: _vm.item,
                          readonly: _vm.readonly,
                          isChangeRequest: _vm.isChangeRequest,
                        },
                        on: {
                          onCancel: _vm.onCancel,
                          onShowTable: _vm.showTable,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VTabItem,
                    { staticClass: "pt-2" },
                    [
                      _c("dataset-tab-business-term", {
                        attrs: {
                          item: _vm.item,
                          valid: _vm.valid,
                          readonly: _vm.readonly,
                          isChangeRequest: _vm.isChangeRequest,
                        },
                        on: { onCancel: _vm.onCancel },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VTabItem,
                    { staticClass: "pt-2" },
                    [
                      _c("dataset-tab-user", {
                        attrs: {
                          item: _vm.item,
                          valid: _vm.valid,
                          readonly: _vm.readonly,
                          isChangeRequest: _vm.isChangeRequest,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VTabItem,
                    { staticClass: "pt-2" },
                    [_c("dataset-tab-lineage", { attrs: { item: _vm.item } })],
                    1
                  ),
                  _c(
                    VTabItem,
                    { staticClass: "pt-2" },
                    [
                      _c("tab-history-log-view", {
                        attrs: { item: _vm.item, typeObject: "dataset" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              [
                _vm.ACCESS_TYPE_FLOW.APPROVE_OWNER,
                _vm.ACCESS_TYPE_FLOW.CHANGE_METADATA,
              ].includes(_vm.isChangeRequest) &&
              _vm.tabActive !== "BUSINESS_TERM"
                ? _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.ACCESS_TYPE_FLOW.APPROVE_OWNER ===
                                    _vm.isChangeRequest
                                    ? _vm.$t("my_tasks.response_reason")
                                    : _vm.$t("my_tasks.response_request")
                                )
                              ),
                            ]
                          ),
                          _c(VTextarea, {
                            attrs: {
                              outlined: "",
                              dense: "",
                              "no-resize": "",
                              rows: "3",
                              rules: [
                                function (v) {
                                  return (
                                    !!v || _vm.$t("my_tasks.modals.required")
                                  )
                                },
                              ],
                              placeholder:
                                _vm.ACCESS_TYPE_FLOW.APPROVE_OWNER ===
                                _vm.isChangeRequest
                                  ? _vm.$t("my_tasks.response_reason")
                                  : _vm.$t("my_tasks.response_request") + "...",
                            },
                            model: {
                              value: _vm.response_text,
                              callback: function ($$v) {
                                _vm.response_text = $$v
                              },
                              expression: "response_text",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { attrs: { sm: "12", lg: "12" } },
                    [
                      _c(
                        "b-alert",
                        {
                          attrs: {
                            show: _vm.dismissCountDown,
                            dismissible: "",
                            variant: "danger",
                          },
                          on: {
                            dismissed: function ($event) {
                              _vm.dismissCountDown = 0
                            },
                            "dismiss-count-down": _vm.countDownChanged,
                          },
                        },
                        [
                          _c("p", [_vm._v(_vm._s(_vm.dangerMessage))]),
                          _c("b-progress", {
                            attrs: {
                              variant: "danger",
                              max: _vm.dismissSecs,
                              value: _vm.dismissCountDown,
                              height: "4px",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.tabActive == "LINEAGE"
                ? _c(VRow, [
                    _c(
                      "div",
                      {
                        staticClass: "text-left mt-3 col-6",
                        staticStyle: { "font-size": "10px" },
                      },
                      [
                        _c("span", { staticClass: "mr-3" }, [
                          _c("img", {
                            staticStyle: { "padding-right": "2px" },
                            attrs: {
                              src: require("@/assets/data_database_icon_177024.png"),
                              width: "13",
                            },
                          }),
                          _c("span", { staticClass: "lineage-color-dataset" }, [
                            _vm._v(
                              _vm._s(_vm.$t("my_tasks.tablas_tasks.dataset")) +
                                "s"
                            ),
                          ]),
                        ]),
                        _c("span", { staticClass: "mr-3" }, [
                          _c("i", { staticClass: "material-icons h6 m-0" }, [
                            _vm._v("leaderboard"),
                          ]),
                          _c("span", { staticClass: "lineage-color-report" }, [
                            _vm._v(
                              _vm._s(_vm.$t("my_tasks.tablas_tasks.report")) +
                                "s"
                            ),
                          ]),
                        ]),
                        _c("span", { staticClass: "mr-3" }, [
                          _c("i", { staticClass: "material-icons h6 m-0" }, [
                            _vm._v("description"),
                          ]),
                          _c("span", { staticClass: "lineage-color-page" }, [
                            _vm._v(
                              _vm._s(_vm.$t("my_tasks.tablas_tasks.pages"))
                            ),
                          ]),
                        ]),
                        _c("span", { staticClass: "mr-3" }, [
                          _c("i", { staticClass: "material-icons h6 m-0" }, [
                            _vm._v("widgets"),
                          ]),
                          _c("span", { staticClass: "lineage-color-app" }, [
                            _vm._v(_vm._s(_vm.$t("my_tasks.modals.app")) + "s"),
                          ]),
                        ]),
                        _c("span", { staticClass: "mr-3" }, [
                          _c("i", { staticClass: "material-icons h6 m-0" }, [
                            _vm._v("grid_on"),
                          ]),
                          _c("span", { staticClass: "lineage-color-table" }, [
                            _vm._v(
                              _vm._s(_vm.$t("my_tasks.tablas_tasks.table")) +
                                "s"
                            ),
                          ]),
                        ]),
                        _c("span", { staticClass: "mr-3" }, [
                          _c("i", { staticClass: "material-icons h6 m-0" }, [
                            _vm._v("dialpad"),
                          ]),
                          _c("span", { staticClass: "lineage-color-table" }, [
                            _vm._v(
                              _vm._s(_vm.$t("my_tasks.tablas_tasks.views"))
                            ),
                          ]),
                        ]),
                        _c("span", { staticClass: "mr-3" }, [
                          _c("i", { staticClass: "material-icons h6 m-0" }, [
                            _vm._v("description"),
                          ]),
                          _c("span", { staticClass: "lineage-color-table" }, [
                            _vm._v(_vm._s(_vm.$t("my_tasks.modals.app"))),
                          ]),
                        ]),
                      ]
                    ),
                    _vm.showButtons &&
                    _vm.tabActive !== "BUSINESS_TERM" &&
                    _vm.tabActive !== "TABLES" &&
                    _vm.isChangeRequest !== _vm.ACCESS_TYPE_FLOW.VIEWER_ONLY
                      ? _c("div", { staticClass: "text-right mt-3 col-6" })
                      : _vm._e(),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }